import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FormContext } from 'blaze-form';
import { modal } from '../../modal/ModalEmitter';
import { getListItemId } from '../../../util/form';

const FormHelperModal = ({ helper, value, disabled }) => {
  const { defaultIcon, config: modalConfig } = modal;

  const { manager } = useContext(FormContext);

  // Likely not ready if this block is hit
  if (!Object.keys(modalConfig).length) {
    return null;
  }

  if (!modalConfig[helper]) {
    console.warn(`Error rendering button for toolbar, the helper: ${helper} doesn't exist.`);
    return null;
  }

  const icon = modalConfig[helper].icon ? (
    <i className={`${modalConfig[helper].icon} fa-fw`} />
  ) : (
    <i className={`${defaultIcon} fa-fw`} />
  );

  const onClick = () => {
    modal.open(helper, { lookupKey: getListItemId(value), manager });
  };

  return (
    <Button
      key={helper}
      variant="secondary"
      size="xs"
      title={modalConfig[helper].title}
      onClick={onClick}
      tabIndex="-1"
      disabled={disabled}
    >
      {icon}
    </Button>
  );
};

FormHelperModal.propTypes = {
  disabled: PropTypes.bool,
  helper: PropTypes.string,
  value: PropTypes.any,
};

export default FormHelperModal;
